/**
 * TEXTVORLAGEN FÜR DIE AUFTRAGSINFO (.498), gepflegt unter Vorlagen.
 *
 * ORIGINALTEXT MARVIN (27.10.2026)
 *   „ich will bei der Auftragsinfo verschiedene Vorlagen erstellen, die dann
 *    oben neben dem Eintrag schreiben angezeigt werden ... wähle sie aus,
 *    klick, Ende."
 */
import { useEffect, useState } from 'react';
import { api, darf, type Anmelder } from '../api.ts';
import { Fehlerkasten, Text, ausFehler, type Fehlerlage } from './Formular.tsx';
import { useFrisch } from './Frisch.tsx';
import { fragen } from './rueckfrage.tsx';

export function AuftragsinfoVorlagen({ ich }: { ich: Anmelder }) {
  const [alle, setAlle] = useState<any[]>([]);
  const [fehler, setFehler] = useState<Fehlerlage | null>(null);
  const [neu, setNeu] = useState({ titel: '', text: '', reihenfolge: '100' });
  const [offen, setOffen] = useState<any | null>(null);
  const [laeuft, setLaeuft] = useState(false);
  const darfPflegen = darf(ich, 'vorlage.pflegen');
  const laden = () => api.auftragsinfoVorlagen(true).then(setAlle).catch((f) => setFehler(ausFehler(f)));
  useEffect(() => { laden(); }, []);
  useFrisch(laden);
  const tu = async (f: () => Promise<any>) => { setLaeuft(true); setFehler(null); try { await f(); await laden(); } catch (x) { setFehler(ausFehler(x)); } finally { setLaeuft(false); } };
  return (
    <div className="karte">
      <h3>Textvorlagen für die Auftragsinfo</h3>
      <div className="leib">
        <p className="klein leise" style={{ marginTop: 0 }}>In der Akte steht neben „Eintrag schreiben“ die Auswahl „Vorlage“. Wählen, und der Text steht als Eintrag in der Auftragsinfo, mit Namen und Datum wie jeder andere.</p>
        <Fehlerkasten lage={fehler} />
        <table className="liste">
          <thead><tr><th style={{ width: 60 }}>Nr.</th><th>Titel</th><th>Text</th><th>Aktiv</th><th /></tr></thead>
          <tbody>
            {alle.map((v) => offen?.id === v.id ? (
              <tr key={v.id} style={{ cursor: 'default' }}>
                <td><input value={offen.reihenfolge} style={{ width: 50 }} onChange={(e) => setOffen({ ...offen, reihenfolge: e.target.value })} /></td>
                <td><input value={offen.titel} style={{ width: '100%' }} onChange={(e) => setOffen({ ...offen, titel: e.target.value })} /></td>
                <td><textarea value={offen.text} rows={3} style={{ width: '100%' }} onChange={(e) => setOffen({ ...offen, text: e.target.value })} /></td>
                <td><input type="checkbox" checked={offen.aktiv} onChange={(e) => setOffen({ ...offen, aktiv: e.target.checked })} /></td>
                <td className="knopfleiste">
                  <button type="button" className="knopf klein haupt" disabled={laeuft} onClick={() => tu(async () => { await api.auftragsinfoVorlageAendern(v.id, { titel: offen.titel, text: offen.text, reihenfolge: Number(offen.reihenfolge), aktiv: offen.aktiv }); setOffen(null); })}>Speichern</button>
                  <button type="button" className="knopf klein" onClick={() => setOffen(null)}>Abbrechen</button>
                </td>
              </tr>
            ) : (
              <tr key={v.id} style={{ cursor: 'default', opacity: v.aktiv ? 1 : 0.55 }}>
                <td className="klein">{v.reihenfolge}</td>
                <td><b>{v.titel}</b></td>
                <td className="klein" style={{ whiteSpace: 'pre-wrap' }}>{v.text}</td>
                <td className="klein">{v.aktiv ? 'ja' : 'nein'}</td>
                <td className="knopfleiste">
                  {darfPflegen && <button type="button" className="knopf klein" onClick={() => setOffen({ ...v, reihenfolge: String(v.reihenfolge) })}>ändern</button>}
                  {darfPflegen && <button type="button" className="knopf klein" disabled={laeuft} onClick={async () => { if (await fragen(`„${v.titel}“ löschen?`)) void tu(() => api.auftragsinfoVorlageWeg(v.id)); }}>löschen</button>}
                </td>
              </tr>
            ))}
            {!alle.length && <tr><td colSpan={5} className="klein leise">Noch keine Vorlage.</td></tr>}
          </tbody>
        </table>
        {darfPflegen && (
          <div style={{ marginTop: 12 }}>
            <b>Neue Vorlage</b>
            <div className="reihe" style={{ alignItems: 'flex-end', flexWrap: 'wrap', gap: 8 }}>
              <Text name="titel" titel="Titel (steht in der Auswahl)" wert={neu.titel} setze={(v) => setNeu({ ...neu, titel: v })} fehler={fehler} breite={260} />
              <Text name="reihenfolge" titel="Nr." wert={neu.reihenfolge} setze={(v) => setNeu({ ...neu, reihenfolge: v })} fehler={fehler} breite={70} />
            </div>
            <Text name="text" titel="Text (so steht er in der Auftragsinfo)" wert={neu.text} setze={(v) => setNeu({ ...neu, text: v })} fehler={fehler} mehrzeilig />
            <button type="button" className="knopf haupt" disabled={laeuft || !neu.titel.trim() || !neu.text.trim()}
                    onClick={() => tu(async () => { await api.auftragsinfoVorlageAnlegen({ titel: neu.titel.trim(), text: neu.text.trim(), reihenfolge: Number(neu.reihenfolge) || 100 }); setNeu({ titel: '', text: '', reihenfolge: '100' }); })}>Anlegen</button>
          </div>
        )}
      </div>
    </div>
  );
}
